import { render, staticRenderFns } from "./dataProcessing.vue?vue&type=template&id=184ba20f&lang=true"
import script from "./dataProcessing.vue?vue&type=script&lang=js"
export * from "./dataProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports